import { render } from "./SideBar.vue?vue&type=template&id=47c8bdcc"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
script.render = render

export default script